//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
import { file_dxos_echo_object } from "./object_pb.js";
import { file_dxos_halo_signed } from "../halo/signed_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/echo/snapshot.proto.
 */
export const file_dxos_echo_snapshot = /*@__PURE__*/ fileDesc("ChhkeG9zL2VjaG8vc25hcHNob3QucHJvdG8SEmR4b3MuZWNoby5zbmFwc2hvdCLIAQoNU3BhY2VTbmFwc2hvdBIRCglzcGFjZV9rZXkYASABKAwSPAoJdGltZWZyYW1lGAIgASgLMiQuZHhvcy5lY2hvLnRpbWVmcmFtZS5UaW1lZnJhbWVWZWN0b3JIAIgBARIWCgl0aW1lc3RhbXAYAyABKAVIAYgBARIyCghkYXRhYmFzZRgLIAEoCzIgLmR4b3MuZWNoby5zbmFwc2hvdC5FY2hvU25hcHNob3RCDAoKX3RpbWVmcmFtZUIMCgpfdGltZXN0YW1wIjsKDEVjaG9TbmFwc2hvdBIrCgVpdGVtcxgBIAMoCzIcLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdGIGcHJvdG8z", [file_dxos_echo_timeframe, file_dxos_echo_object, file_dxos_halo_signed, file_dxos_keys]);
/**
 * Describes the message dxos.echo.snapshot.SpaceSnapshot.
 * Use `create(SpaceSnapshotSchema)` to create a new message.
 */
export const SpaceSnapshotSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_snapshot, 0);
/**
 * Describes the message dxos.echo.snapshot.EchoSnapshot.
 * Use `create(EchoSnapshotSchema)` to create a new message.
 */
export const EchoSnapshotSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_snapshot, 1);
//# sourceMappingURL=snapshot_pb.js.map